<template>
<draggable
    :distanceRight='8'
    :distanceBottom='200'
    :isScrollHidden='false'
    :isCanDraggable='true'
    :zIndex="100">
  <div
    ref="floatNavsBlock"
    class="fixed-navs"
  >
    <div v-if="isShow">
      <span class="float-navs" @click="() => { $router.push({ name: 'Home' }) }">
        <img src="../../assets/nav/home.png" alt />
        <span>首页</span>
      </span>
      <span class="float-navs" @click="() => { $router.push({ name: 'Order' }) }">
        <img src="../../assets/nav/order.png" alt />
        <span>订单</span>
      </span>
      <span class="float-navs" @click="() => { $router.push({ name: 'My' }) }">
        <img src="../../assets/nav/my.png" alt />
        <span>我的</span>
      </span>
      <span class="float-navs" @click="backTop">
        <img src="../../assets/nav/top.png" alt />
        <span>顶部</span>
      </span>
      <span class="float-navs" @click="toggleShow">
        <img src="../../assets/nav/close.png" alt />
        <span>关闭</span>
      </span>
    </div>
    <div v-else>
      <span class="float-navs" @click="toggleShow">
        <img src="../../assets/nav/nav.png" alt />
        <span>导航</span>
      </span>
    </div>
  </div>
  </draggable>
</template>
<script type="text/babel">
import Draggable from './draggable.vue'

export default {
  name: 'float-navs',
  components: {
    Draggable
  },
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    toggleShow () {
      this.isShow = !this.isShow
    },
    backTop () {
      window.scroll(0, 0)
    }
  }
}
</script>

<style lang="less">
.fixed-navs {
  z-index: 9999;
  transition: all 0.3s;
  position: relative;
  width: 84px;
  div{
    position: absolute;
    bottom: 0;
  }
  .float-navs {
    width: 84px;
    height: 84px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #fff;
    border: 2px solid #16B998;
    border-radius: 42px;
    box-shadow:0px 8px 12px rgba(22,185,152,0.12);
    img {
      width: 30px;
      margin-bottom: 8px;
    }
    span {
      font-size: 14px;
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/float-navs/index.vue